import * as React from 'react';

import { NewAdfoxBannerContainer } from '../NewAdfoxBanner';
import { getBannerSize } from './helpers';
import { TBannerType } from '../../../types/banner';
import { useSelector } from 'react-redux';
import { selectUserIsAgent } from '../../../selectors/user';
import { selectAdfoxInfo } from '../../../selectors/newbuilding';

export interface ITgbBannerProps {
  type: TBannerType;
}

export const TgbBannerContainer = (props: ITgbBannerProps) => {
  const isAgent = useSelector(selectUserIsAgent);
  const adfoxInfo = useSelector(selectAdfoxInfo);
  const { type } = props;
  const agentMark = isAgent ? 'agent' : 'not_agent';
  const sizeProps = getBannerSize(type);
  const bannerParams = type === 'aside' ? { p1: 'crypa', p2: 'fkhh' } : { p1: 'chwon', p2: 'gprh' };

  const params = {
    ...adfoxInfo,
    ...bannerParams,
    puid10: agentMark,
  };

  return (
    <NewAdfoxBannerContainer {...sizeProps} ownerId={202100} disableYan={isAgent} params={params} bannerType={type} />
  );
};
